export enum Errors {
  EmptyCategories = 'emptyCategories',
}
